import Tabs from "../../Enquiries/MyEnquiry/tabs";
import MyTeam from "../../Enquiries/MyTeam/tabs";
import { Col, Row } from "react-bootstrap";
import "./index.scss";
import SearchQuery from "../../Enquiries/SearchResults/Query";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import QueuesTopRow from "../../Enquiries/QueueLists/TopRow";

function SecondRow(props: any) {
    const SiteInformation = useSelector((state: RootState) => state.SiteInformation);
    return (
        <>
            <Row className="secondRow">
                {SiteInformation.queuesListVisible && <QueuesTopRow FullWidth={props.FullWidth}></QueuesTopRow>}
                {SiteInformation.enquiriesListVisible && <Tabs FullWidth={props.FullWidth}></Tabs>}
                {SiteInformation.searchResultsVisible && <SearchQuery FullWidth={props.FullWidth}></SearchQuery>}
                {SiteInformation.teamEnquiriesVisible && <MyTeam FullWidth={props.FullWidth}></MyTeam>}
            </Row>
        </>
    );
}
export default SecondRow;
